export const TOPIC_STATUS = "/topic/device-online-status";
export const TOPIC_MONITORING = "/topic/MonitorPacketDto";
export const TOPIC_FIRMWARE_UPDATE_PACKET_STATUS =
  "/topic/FirmwareUpdatePacketStatusDto";
export const TOPIC_FIRMWARE_UPDATE_STATUS = "/topic/FirmwareUpdateStatusDto";
export const TOPIC_ONLINE_DEVICES = "/topic/Device";
export const TOPIC_FIRMWARE_UPDATE_COMPLETED =
  "/topic/FirmwareUpdateCompleteDto";
export const TOPIC_HANDHELD_CONNECTION = "/topic/HandheldConnectionDto";
